import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {}
}

export default createCrudModule({
  client: api.client,
  resource: 'diaryWeeks',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn: (id, params) => `/projects/${params.project_id}/invoices/${params.invoice_id}/diary${id ? '/'+id : ''}`,
  state
});